import { List } from 'immutable'
import {
  MOSAIC_CREATOR_ROLE_IDS,
  MOSAIC_VIEW_SUBSCRIPTION_IDS,
} from './mosaic-entitlements'

export { MOSAIC_CREATOR_ROLE_IDS, MOSAIC_VIEW_SUBSCRIPTION_IDS } from './mosaic-entitlements'

export function hasMosaicCreatorRole (roleIds) {
  const ids = List.isList(roleIds) ? roleIds.toJS() : (roleIds ?? [])
  return MOSAIC_CREATOR_ROLE_IDS.some((id) => ids.includes(id))
}

export function hasMosaicViewAccess ({ roleIds, subscriptions }) {
  if (hasMosaicCreatorRole(roleIds)) return true
  const subs = List.isList(subscriptions) ? subscriptions.toJS() : (subscriptions ?? [])
  return MOSAIC_VIEW_SUBSCRIPTION_IDS.some((id) => subs.includes(id))
}
